import PropTypes from 'prop-types'
import { useHubspotChat } from './useHubSpotChat'
import { withRouter } from '../Routing/withRouter'
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
// import history from '../../../history'

const HubSpotChat = (props) => {
  const {refreshHandler } = useHubspotChat(props.portalId)

  const location = useLocation();

  useEffect(() => {
    refreshHandler()
  }, [location, refreshHandler]);
  return (
    null
  )
}

HubSpotChat.propTypes = {
  portalId: PropTypes.string.isRequired
}
export default withRouter(HubSpotChat);
